import Swal from "sweetalert2";
import { Variables } from "./variables";
import { MedicalDept } from "@/enums/common.enums";
import { YnEnum } from "../enums/common.enums";
import enums from "@/enums/common.enums";
import { getCountryConfig, DEFAULT_LOCALE } from "@/constants/countryPhone";

export const MedicalDeptText = {
  DENT: "치과",
  DERM: "피부과",
  PS: "성형외과",
  OS: "정형외과",
  OPH: "안과",
  KM: "한의원",
  NS: "신경외과",
  CS: "흉부외과",
  COMMON: "공통",
  VET_COMMON: "수의과",
};

export function convertMedicalDept(value) {
  return MedicalDeptText[value] || "";
}

// dialog 열기
export async function openDialog(text, icon, confirmText) {
  await Swal.fire({
    text: text,
    icon: icon,
    buttonsStyling: false,
    confirmButtonText: confirmText,
    heightAuto: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
}

// confirmText: 확인 버튼에 동작 이름(「초기화」「삭제」), danger: 되돌릴 수 없는 동작이면 빨간 확인 버튼
export async function confirmDialog(title, text, { confirmText = "확인", danger = false } = {}) {
  const response = await Swal.fire({
    title: title,
    text: text,
    buttonsStyling: false,
    confirmButtonText: confirmText,
    cancelButtonText: "취소",
    showCancelButton: true,
    heightAuto: true,
    customClass: {
      confirmButton: `btn ${danger ? "btn-danger-confirm" : "btn-primary-confirm"} btn-hover`,
      cancelButton: "btn btn-secondary-cancel btn-hover",
    },
  });
  if (response) {
    const isConfirmed = response.isConfirmed;
    return isConfirmed;
  } else {
    return false;
  }
}

// 날짜 관련 utils

export const convertDateWithSlash = (dateString) => {
  if (dateString) {
    const [year, month, day] = dateString.split("-");
    const newMonth = month.replace(/^0+/, "");
    const newDay = day.replace(/^0+/, "");
    return `${newMonth}/${newDay}`;
  } else {
    return "-";
  }
};

// 날짜만 보여주기(스트링 잘라서)
export const convertDate = (dateString) => {
  if (dateString) {
    return dateString.split("T")[0].replaceAll("-", "/");
  } else {
    return `-`;
  }
};

// 날짜와 시간 보여주기(스트링 잘라서)
// ISO 형식(…T…)이 아닌 값은 자르지 않고 그대로 보여준다. 서버는 접속 기록이 없는 계정에 "-" 를 내려주는데,
// 이를 자르다 예외가 나면 그 행을 그리는 표 전체가 깨져 같은 화면의 버튼(메뉴 및 권한 관리 등)도 동작하지 않는다.
export const convertDateTime = (dateString) => {
  if (typeof dateString === "string" && dateString.includes("T")) {
    const date = dateString.split("T")[0].replaceAll("-", "/");
    const time = dateString.split("T")[1].split(".")[0];
    return `${date} ${time}`;
  } else {
    return dateString ? String(dateString) : `-`;
  }
};

// 로컬 시간으로 변환 (ISO 8601 형식 변환)
export const convertToLocalTime = (dateString) => {
  if (!dateString) return "-";

  try {
    const date = new Date(dateString);

    // 날짜가 유효한지 확인
    if (isNaN(date.getTime())) {
      return "-";
    }

    // 로컬 시간 형식으로 변환 YYYY/MM/DD HH:mm:ss
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error("Date conversion error:", error);
    return "-";
  }
};

// 년 월 일로 표시
export const convertDateWithKorean = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}년 ${month}월 ${day}일`;
  } else {
    return `-`;
  }
};

export const formatInputToDate = (input) => {
  const onlyNumbers = input.replace(/\D/g, ""); // remove non-digits

  if (onlyNumbers.length <= 4) {
    return onlyNumbers;
  } else if (onlyNumbers.length <= 6) {
    let year = onlyNumbers.slice(0, 4);
    let month = onlyNumbers.slice(4);

    // Validate month
    if (parseInt(month, 10) > 12) {
      month = "12";
    }

    return `${year}/${month}`;
  } else {
    let year = onlyNumbers.slice(0, 4);
    let month = onlyNumbers.slice(4, 6);
    let day = onlyNumbers.slice(6, 8);

    // Validate month and day
    if (parseInt(month, 10) > 12) {
      month = "12";
    }
    if (parseInt(day, 10) > 31) {
      day = "31";
    }
    if (year === "0000") {
      year = new Date().getFullYear();
    }
    if (month === "00") {
      month = "01";
    }
    if (day === "00") {
      day = "01";
    }

    return `${year}/${month}/${day}`;
  }
};

export const jwtDecoder = (jwtCode) => {
  if (jwtCode) {
    const base64Url = jwtCode.split(".")[1];
    const companyId = JSON.parse(atob(base64Url))["sub"];
    return companyId;
  } else {
    return "";
  }
};

export const changeBytesToKilos = (bytes) => {
  return bytes / 1024 / 1024;
};

// dialog 열기
export const oneBtnDialog = async (title, text, needsRefresh) => {
  await Swal.fire({
    title: title,
    text: text,
    buttonsStyling: false,
    confirmButtonText: "확인",
    heightAuto: true,
    customClass: {
      confirmButton: "btn btn-primary",
    },
  }).then(() => {
    if (needsRefresh) location.reload();
  });
};

export const oneBtnHtmlDialog = async (title, htmlText, needsRefresh) => {
  await Swal.fire({
    title: title,
    html: htmlText,
    buttonsStyling: false,
    showCancelButton: false,
    heightAuto: true,
    confirmButtonText: "확인",
    customClass: {
      confirmButton: "btn btn-primary",
    },
    reverseButtons: true,
  }).then(() => {
    if (needsRefresh) location.reload();
  });
};

export const twoBtnDialog = async (title, text, confirmBtnText) => {
  const response = await Swal.fire({
    title: title,
    text: text,
    buttonsStyling: false,
    confirmButtonText: confirmBtnText ? confirmBtnText : "확인",
    cancelButtonText: "취소",
    showCancelButton: true,
    heightAuto: true,
    customClass: {
      confirmButton: "btn btn-primary-confirm btn-hover swal-button-custom",
      cancelButton: "btn btn-secondary-cancel btn-hover swal-button-custom",
    },
    reverseButtons: true,
  });
  if (response) {
    const isConfirmed = response.isConfirmed;
    return isConfirmed;
  } else {
    return false;
  }
};

export const twoBtnHtmlDialog = async (title, htmlText, confirmBtnText) => {
  const response = await Swal.fire({
    title: title,
    html: htmlText,
    buttonsStyling: false,
    confirmButtonText: confirmBtnText ? confirmBtnText : "확인",
    cancelButtonText: "취소",
    showCancelButton: true,
    heightAuto: true,
    customClass: {
      confirmButton: "btn btn-primary-confirm btn-hover swal-button-custom",
      cancelButton: "btn btn-secondary-cancel btn-hover swal-button-custom",
    },
    reverseButtons: true,
  });
  if (response) {
    const isConfirmed = response.isConfirmed;
    return isConfirmed;
  } else {
    return false;
  }
};

export const addCommaToNumber = (value) => {
  if (value) return value.toLocaleString("en-US");
  else return value;
};

export const formatCommaNumber = (value) => {
  if (value) return value.toLocaleString("en-US");
  else return value;
};

export const phoneNumberFormatter = (phoneNumber) => {
  if (!phoneNumber) return "";
  else {
    const value = phoneNumber.replace(/[^0-9]/g, "");
    return value.replace(
      /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
      "$1-$2-$3"
    );
  }
};

/**
 * Locale-aware phone number formatter
 * @param {string} phoneNumber - Raw phone number input
 * @param {string} locale - Locale code (ko, zh, en, ja, vi)
 * @returns {string} Formatted phone number based on locale
 */
export const phoneNumberFormatterByLocale = (
  phoneNumber,
  locale = DEFAULT_LOCALE
) => {
  if (!phoneNumber) return "";

  const value = phoneNumber.replace(/[^0-9]/g, "");
  if (!value) return "";

  const config = getCountryConfig(locale);

  // For Korean numbers, use the original complex pattern
  if (locale === "ko") {
    return value.replace(
      /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
      "$1-$2-$3"
    );
  }

  // For other locales, use the configured pattern
  if (config.formatPattern && value.length >= 10) {
    return value.replace(config.formatPattern, config.formatReplacement);
  }

  return value;
};

export const businessNumberFormatter = (businessNumber) => {
  if (!businessNumber) return "";
  const value = businessNumber.replace(/[^0-9]/g, "");

  if (value.length <= 3) {
    return value;
  } else if (value.length <= 5) {
    return value.replace(/(\d{3})(\d{0,2})/, "$1-$2");
  } else {
    return value.replace(/(\d{3})(\d{2})(\d{0,5})/, "$1-$2-$3");
  }
};

export const decodeUtfText = (text) => {
  const byteArray = Uint8Array.from(text, (c) => c.charCodeAt(0));
  const decoder = new TextDecoder("utf-8");
  const decodedText = decoder.decode(byteArray);
  return decodedText;
};

export const decimalFormatter = (number) => {
  number = number.replace(/[^0-9.]/g, "");

  const dotCount = (number.match(/\./g) || []).length;
  if (dotCount > 1) {
    number = number.replace(/\./g, (match, offset) =>
      offset === number.indexOf(".") ? "." : ""
    );
  }

  const parts = number.split(".");
  if (parts.length > 2) {
    number = parts[0] + "." + parts[1];
  } else if (parts.length === 2 && parts[1].length > 2) {
    number = parts[0] + "." + parts[1].slice(0, 2);
  }

  return number;
};

export const getValueByTraitType = (attributes, targetValue) => {
  let value = "";
  if (attributes) {
    for (const item of attributes) {
      if (item.trait_type === targetValue) {
        value = item.value;
      }
    }
  }
  return value;
};

export const getValueByKeyName = (array, key) => {
  let value = "";
  for (const item of array) {
    if (item.key === key) {
      value = item.value;
      break;
    }
  }

  return value;
};

export const calcIsNew = (dateStr) => {
  const itemDate = new Date(dateStr);
  const currentDate = new Date();

  const differenceInTime = currentDate.getTime() - itemDate.getTime();
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);

  const daysThreshold = Variables.notice.numberOfDatesForNewPosts;

  return Math.floor(differenceInDays) < daysThreshold;
};

export const convertDeptText = (input) => {
  switch (input) {
    case MedicalDept.DENT:
      return { certificateText: "인증서" };
    case MedicalDept.OPH:
      return { certificateText: "확인서" };
    default:
      return { certificateText: "인증서" };
  }
};

export const parseStringifiedObject = (object) => {
  return JSON.parse(JSON.stringify(object));
};

export const logging = () => {
  return {
    exceptProd: (txt, obj) => {
      if (process.env.NODE_ENV !== "production") {
        console.log(txt, obj);
      }
    },
  };
};

export const convertMonthAndYearText = (input) => {
  if (!input) return "";
  if (input < 12) return `${input}개월`;
  return `${input / 12}년`;
};

export const formatDate = () => {
  const formatting = (date) => {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day];
  };

  return {
    yyyymmdd: (date) => {
      return formatting(date).join("");
    },
    "yyyy-mm-dd": (date) => {
      return formatting(date).join("-");
    },
    unixTimeToYYYYMMDD: (unixTime) => {
      const unixTimeSec = Math.floor(unixTime / 1000); // 밀리초를 초로 변환
      const date = new Date(unixTimeSec * 1000); // Date 객체 생성
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}${month}${day}`;
    },
    "sqlserverDateToyyyy/mm/dd": (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // 월은 0부터 시작하므로 1을 더해야 합니다.
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}/${month}/${day}`;
    },
    getCurrentUnixTime: () => {
      const now = new Date();
      return Math.floor(now.getTime());
    },
    getPastDatesInUnixTime: (value) => {
      const now = new Date();
      const threeMonthsAgo = new Date(now.setMonth(now.getMonth() - 3));
      const twelveMonthsAgo = new Date(now.setMonth(now.getMonth() - 9));
      const thirtySixMonthsAgo = new Date(now.setMonth(now.getMonth() - 24));

      now.setMonth(now.getMonth() + 36);

      const nowUnix = Math.floor(now.getTime());
      const threeMonthsAgoUnix = Math.floor(threeMonthsAgo.getTime());
      const twelveMonthsAgoUnix = Math.floor(twelveMonthsAgo.getTime());
      const thirtySixMonthsAgoUnix = Math.floor(thirtySixMonthsAgo.getTime());

      switch (value) {
        case 3:
          return threeMonthsAgoUnix;
        case 12:
          return twelveMonthsAgoUnix;
        case 36:
          return thirtySixMonthsAgoUnix;
        default:
          return nowUnix;
      }
    },
  };
};

export const compareUnixDates = (startUnix, endUnix) => {
  let startDate = new Date(startUnix);
  let endDate = new Date(endUnix);

  const setMidnight = (date) => {
    date.setHours(0, 0, 0, 0);
    return date;
  };

  // 시작일과 종료일의 시간을 자정으로 설정
  startDate = setMidnight(startDate);
  endDate = setMidnight(endDate);

  // Unix 시간으로 다시 변환
  const startUnixMidnight = startDate.getTime();
  const endUnixMidnight = endDate.getTime();

  // 시작일이 종료일 이전 또는 같은지 비교
  return startUnixMidnight <= endUnixMidnight;
};

export const removeHyphen = (text) => {
  if (!text) return "";
  return text.replaceAll(/-/g, "");
};

export const convertBoolToYn = (bool) => {
  if (bool === true) return YnEnum.Y;
  if (bool === false) return YnEnum.N;
  return "";
};

export const convertYnToKorean = (ynEnum) => {
  if (ynEnum === YnEnum.Y) return "예";
  if (ynEnum === YnEnum.N) return "아니오";
};

export const roleConverter = (input) => {
  const { ROLES } = enums();
  switch (input) {
    case ROLES.HOSPITAL.key:
      return ROLES.HOSPITAL.label;
    case ROLES.MANUFACTURER.key:
      return ROLES.MANUFACTURER.label;
    case ROLES.CERTILIFE.key:
      return ROLES.CERTILIFE.label;
    case ROLES.CUSTOMER.key:
      return ROLES.CUSTOMER.label;
  }
};

export const deepCopy = (obj) => {
  if (!obj) return;
  return JSON.parse(JSON.stringify(obj));
};

export const convertYnToBool = (ynEnum) => {
  if (ynEnum === YnEnum.Y) return true;
  if (ynEnum === YnEnum.N) return false;
  return ynEnum;
};

export const boolToYn = (bool) => {
  if (bool === true) return YnEnum.Y;
  if (bool === false) return YnEnum.N;
  return bool;
};

export const dateUtils = () => {
  return {
    unixTimeToYYYYMMDD(unixTime) {
      let date = new Date(unixTime);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date.getDate().toString().padStart(2, "0")
      );
    },
    YYYYMMDDtoUnixTime(dateString) {
      let date = new Date(dateString);
      return date.getTime();
    },
  };
};
